import EmptyMessageWithIcon from '@/components/EmptyMessageWithIcon/EmptyMessageWithIcon';

export default EmptyMessageWithIcon;
